import { overlayStrategemFadeMs } from './overlayStrategemTiming';

/** Kamikaze (strategem 314): overlay visible before unit destruction / server resolution */
export const KAMIKAZE_ANNOUNCE_DURATION_MS = overlayStrategemFadeMs(314);
export const KAMIKAZE_TARGET_IMAGE_PATH = '/images/kamikaze_target.png';
export const KAMIKAZE_SOUND_PATH = '/sounds/kamikaze.mp3';
